import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./App";
import { AppProvider } from "./context/AppContext";
import { FinanceProvider } from "./context/FinanceContext";
import { ModuleSettingsProvider } from "./context/ModuleSettingsContext";
import { ConstructionProvider } from "./context/ConstructionContext";
import { I18nProvider } from "./i18n";

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <AppProvider>
      <FinanceProvider>
        <ModuleSettingsProvider>
          <ConstructionProvider>
            <I18nProvider>
              <App />
            </I18nProvider>
          </ConstructionProvider>
        </ModuleSettingsProvider>
      </FinanceProvider>
    </AppProvider>
  </StrictMode>
);
